import { name } from './slice';
import type { ILinkedHotel } from './types';

export const getLinkedHotelsList = (state): ILinkedHotel[] | undefined =>
  state[name].list;
